/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ billable: NonNullable<unknown>, accruing: NonNullable<unknown>, month: NonNullable<unknown> }} Partner_Billing_Board_Alltime_Split_FilteredInputs */



/**
* | output |
* | --- |
* | "{billable} billable now (closed months) · {accruing} accruing in {month} (open month) — neither the month nor the filter narrows these." |
*
* @param {Partner_Billing_Board_Alltime_Split_FilteredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_alltime_split_filtered = /** @type {((inputs: Partner_Billing_Board_Alltime_Split_FilteredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Alltime_Split_FilteredInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.billable} jetzt fakturierbar (abgeschlossene Monate) · ${i?.accruing} laufend in ${i?.month} (offener Monat) — weder Monat noch Filter schränken diese Beträge ein.`)
	return /** @type {LocalizedString} */ (`${i?.billable} billable now (closed months) · ${i?.accruing} accruing in ${i?.month} (open month) — neither the month nor the filter narrows these.`)
});